/**
 * Wall-outlet on/off switch tip — mirrors iOS ElectricalAdapterData.showsWallOutletSwitchWarning.
 */

import type { ElectricalInfo } from './countryInfoLookups';
import { normalizeCountryName } from './countryInfoLookups';

/** ISO2 where Type G is used or commonly accepted. */
export const TYPE_G_COUNTRY_ISO2_CODES = new Set([
  'AE',
  'BD',
  'BH',
  'BN',
  'CY',
  'DM',
  'ET',
  'FK',
  'GB',
  'GD',
  'GG',
  'GH',
  'GI',
  'GM',
  'HK',
  'IE',
  'IM',
  'IQ',
  'JE',
  'JO',
  'KE',
  'KH',
  'KN',
  'KW',
  'LC',
  'LK',
  'LR',
  'MO',
  'MM',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MY',
  'NG',
  'OM',
  'QA',
  'RW',
  'SA',
  'SC',
  'SD',
  'SG',
  'SH',
  'SL',
  'SO',
  'SS',
  'TZ',
  'UG',
  'VC',
  'YE',
  'ZM',
  'ZW',
]);

/** Type G set plus Australia / New Zealand / Fiji (Type I Oceania switches). */
export const WALL_OUTLET_SWITCH_WARNING_ISO2_CODES = new Set([
  ...TYPE_G_COUNTRY_ISO2_CODES,
  'AU',
  'NZ',
  'FJ',
]);

const WALL_SWITCH_COUNTRY_NAMES = new Set([
  'australia',
  'new zealand',
  'fiji',
  'united kingdom',
  'uk',
  'ireland',
  'hong kong',
  'macau',
  'macao',
]);

export function showsWallOutletSwitchWarning(options: {
  iso2?: string | null;
  country?: string | null;
  adapterInfo?: ElectricalInfo | null;
}): boolean {
  const iso2 = options.iso2?.trim().toUpperCase();
  if (iso2 && WALL_OUTLET_SWITCH_WARNING_ISO2_CODES.has(iso2)) return true;

  const country = options.country?.trim();
  if (country) {
    const normalized = normalizeCountryName(country).toLowerCase();
    if (
      WALL_SWITCH_COUNTRY_NAMES.has(normalized) ||
      WALL_SWITCH_COUNTRY_NAMES.has(country.toLowerCase())
    ) {
      return true;
    }
  }

  if (options.adapterInfo?.plugTypes.includes('G')) return true;
  return false;
}
